import { gql } from '@apollo/client'
import { EventFragments } from './queries'

export const CREATE_EVENT_MUTATION = gql`
  mutation CreateEvent(
    $thread: ID!
    $startsAt: DateTime!
    $endsAt: DateTime
    $location: String
    $registrationDeadline: DateTime
    $questions: [EventQuestionInput!]
  ) {
    createEvent(
      thread: $thread
      startsAt: $startsAt
      endsAt: $endsAt
      location: $location
      registrationDeadline: $registrationDeadline
      questions: $questions
    ) {
      ok
      event {
        id
      }
    }
  }
`

export const PATCH_EVENT_MUTATION = gql`
  mutation PatchEvent(
    $id: ID!
    $startsAt: DateTime
    $endsAt: DateTime
    $location: String
    $registrationDeadline: DateTime
    $questions: [EventQuestionInput!]
  ) {
    patchEvent(
      id: $id
      startsAt: $startsAt
      endsAt: $endsAt
      location: $location
      registrationDeadline: $registrationDeadline
      questions: $questions
    ) {
      ok
      event {
        ...EventInfo
      }
    }
  }
  ${EventFragments.info}
`

export const DELETE_EVENT_MUTATION = gql`
  mutation DeleteEvent($id: ID!) {
    deleteEvent(id: $id) {
      found
      deletedId
    }
  }
`

export const RESPOND_TO_EVENT_MUTATION = gql`
  mutation RespondToEvent(
    $event: ID!
    $status: EventRegistrationStatus!
    $note: String
    $answers: [EventAnswerInput!]
  ) {
    respondToEvent(
      event: $event
      status: $status
      note: $note
      answers: $answers
    ) {
      ok
      registration {
        id
        status
        note
        updatedAt
        answers {
          id
          value
          question {
            id
          }
        }
      }
      event {
        ...EventInfo
      }
    }
  }
  ${EventFragments.info}
`

export const EXPORT_EVENT_REGISTRATIONS_MUTATION = gql`
  mutation ExportEventRegistrations(
    $event: ID!
    $exportFormat: ExportFormat
    $exportOption: ExportOption!
  ) {
    exportEventRegistrations(
      event: $event
      exportFormat: $exportFormat
      exportOption: $exportOption
    ) {
      ok
      html
      exportTimeout
    }
  }
`
